export default __webpack_public_path__ + "static/media/digital_wallet_en.265968a0.png";